// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 296 ? "ea88be26" : chunkId) + "." + {"296":"1a112e62a60bad04","9260":"845c60e0bc97e8c5","9703":"be7a15dab3b1a4d8"}[chunkId] + ".js";
};